// extracted by mini-css-extract-plugin
module.exports = {"light":"brand_light__0Tu_4","dark":"brand_dark__Q4gdr"};